<template>
  <div :class="['candle-chart']">
    <ul :class="['candle-chart-bars']">
      <li v-for="(item, index) in set" :style="{height: height(item)}" :key="index" />
    </ul>
  </div>
</template>
<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      total: 0
    }
  },
  props: {
    set: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    set () {
      this.getTotal()
    }
  },
  mounted () {
    this.getTotal()
  },
  methods: {
    height (value = 0) {
      return this.total === 0 ? 0 : Math.round(value * 100 / this.total) + '%'
    },
    getTotal () {
      this.set.forEach(value => {
        this.total = this.total + value
      })
    }
  }
}
</script>
<style>
.candle-chart,
.candle-chart *
{
  margin: 0;
  padding: 0;
  list-style: none;
}

.candle-chart .candle-chart-bars
{
  height: 50px;
  display: flex;
  background: #606060;
}

.candle-chart .candle-chart-bars li
{
  background: #b00;
  align-self: flex-end;
  width: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/chart.vue